import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import paymentsListEN from './apps/flash/payments-list/en.json';
import flashCardEN from './apps/flash/card/en.json';
import paymentLayoutEN from './apps/flash/payment-layout/en.json';
import bankInstallmentEN from './apps/flash/bank-installment/en.json';
import easypaisaEN from './apps/flash/easypaisa/en.json';
import jazzcashEN from './apps/flash/jazzcash/en.json';
import niftEN from './apps/flash/nift/en.json';
import valuEN from './apps/flash/valu/en.json';
import forsaEN from './apps/flash/forsa/en.json';
import forsav2EN from './apps/flash/forsav2/en.json';
import souhoolaEN from './apps/flash/souhoola/en.json';
import midTakseetEN from './apps/flash/mid-takseet/en.json';
import spotiiEN from './apps/flash/spotii/en.json';
import tappyEN from './apps/flash/tappy/en.json';
import tamaraEN from './apps/flash/tamara/en.json';
import truEN from './apps/flash/tru/en.json';
import googlePayEN from './apps/flash/google-pay/en.json';
import postpayEN from './apps/flash/postpay/en.json';
import walletEN from './apps/flash/wallet/en.json';
import premiumEN from './apps/flash/premium/en.json';
import amanEN from './apps/flash/aman/en.json';
import amanv3EN from './apps/flash/amanv3/en.json';
import halanEN from './apps/flash/halan/en.json';
import instapayEN from './apps/flash/instapay/en.json';
import symplv3EN from './apps/flash/symplv3/en.json';
import fastcheckoutEN from './apps/flash/fastcheckout/en.json';
import tabElementEN from './apps/flash/tab-element/en.json';
import stcpayEN from './apps/flash/stcpay/en.json';
import contactEN from './apps/flash/contact/en.json';
import paymentsEN from './apps/flash/payments/en.json';
import klivvrEN from './apps/flash/klivvr/en.json';
import MyloLibEN from './apps/flash/mylo/en.json';
import MadfuLibEN from './apps/flash/madfu/en.json';
import SharedEN from './apps/flash/shared/en.json';
import splitPaymentsEN from './apps/flash/split-payments/en.json';

import cardEN from './libs/card/en.json';
import kitComponentsEN from './libs/kit-components/en.json';
import niftLibEN from './libs/nift/en.json';
import easypaisaLibEN from './libs/easypaisa/en.json';
import jazzcashLibEN from './libs/jazzcash/en.json';
import valuLibEN from './libs/valu/en.json';
import postpayLibEN from './libs/postpay/en.json';
import tabbyLibEN from './libs/tabby/en.json';
import tamaraLibEN from './libs/tamara/en.json';
import walletLibEN from './libs/wallet/en.json';
import premiumLibEN from './libs/premium/en.json';
import bankInstallmentLibEN from './libs/bank-installment/en.json';
import souhoolaLibEN from './libs/souhoola/en.json';
import midTakseetLibEN from './libs/mid-takseet/en.json';
import forsaLibEN from './libs/forsa/en.json';
import forsav2LibEN from './libs/forsav2/en.json';
import symplv3LibEN from './libs/symplv3/en.json';
import amanLibEN from './libs/aman/en.json';
import amanv3LibEN from './libs/amanv3/en.json';
import stcpayLibEN from './libs/stcpay/en.json';
import truLibEN from './libs/tru/en.json';
import contactLibEN from './libs/contact/en.json';
import halanLibEN from './libs/halan/en.json';
import instapayLibEN from './libs/instapay/en.json';
import digitalWalletLibEN from './libs/digital-wallet/en.json';
import knetLibEN from './libs/knet/en.json';
import knetApplePayLibEN from './libs/knet-apple-pay/en.json';
import sevenLibEN from './libs/seven/en.json';
import klivvrLibEN from './libs/klivvr/en.json';

const en = {
  flash: {
    paymentsList: paymentsListEN,
    card: flashCardEN,
    paymentLayout: paymentLayoutEN,
    bankInstallment: bankInstallmentEN,
    valu: valuEN,
    forsa: forsaEN,
    forsav2: forsav2EN,
    spotii: spotiiEN,
    postpay: postpayEN,
    tappy: tappyEN,
    tamara: tamaraEN,
    googlePay: googlePayEN,
    wallet: walletEN,
    nift: niftEN,
    jazzcash: jazzcashEN,
    easypaisa: easypaisaEN,
    premium: premiumEN,
    souhoola: souhoolaEN,
    midTakseet: midTakseetEN,
    stcpay: stcpayEN,
    aman: amanEN,
    contact: contactEN,
    amanv3: amanv3EN,
    payments: paymentsEN,
    halan: halanEN,
    instapay: instapayEN,
    symplv3: symplv3EN,
    tru: truEN,
    tabElement: tabElementEN,
    splitPayments: splitPaymentsEN,
    fastcheckout: fastcheckoutEN,
    klivvr: klivvrEN,
    mylo: MyloLibEN,
    madfu: MadfuLibEN,
    shared: SharedEN,
    fastcheckout: fastcheckoutEN,
  },
  card: cardEN,
  kitComponents: kitComponentsEN,
  bankInstallment: bankInstallmentLibEN,
  nift: niftLibEN,
  easypaisa: easypaisaLibEN,
  jazzcash: jazzcashLibEN,
  valu: valuLibEN,
  postpay: postpayLibEN,
  tabby: tabbyLibEN,
  tamara: tamaraLibEN,
  wallet: walletLibEN,
  premium: premiumLibEN,
  souhoola: souhoolaLibEN,
  midTakseet: midTakseetLibEN,
  forsa: forsaLibEN,
  forsav2: forsav2LibEN,
  stcpay: stcpayLibEN,
  tru: truLibEN,
  aman: amanLibEN,
  contact: contactLibEN,
  amanv3: amanv3LibEN,
  halan: halanLibEN,
  instapay: instapayLibEN,
  symplv3: symplv3LibEN,
  digitalWallet: digitalWalletLibEN,
  knetApplePay: knetApplePayLibEN,
  knet: knetLibEN,
  seven: sevenLibEN,
  klivvr: klivvrLibEN,
};

import CardPixelEn from './apps/elements/card/en.json';
import CardPixelAr from './apps/elements/card/ar.json';

i18n.use(initReactI18next).init({
  lng: 'en',
  debug: false,
  fallbackLng: 'en',
  // Only English (default + fallback) is bundled eagerly. Arabic and Urdu are
  // code-split into their own chunks and loaded on demand the first time the
  // user switches to them (see the changeLanguage wrapper below). This keeps
  // ~2/3 of the translation payload off the main entry chunk.
  resources: {
    en,
  },
  backend: {
    loadPath: './language/{{lng}}/{{ns}}.json',
  },
});

// Dynamic-import loaders for the non-default languages. Webpack splits each of
// these into a separate async chunk.
const languageLoaders = {
  ar: () => import('./resources/ar'),
  ur: () => import('./resources/ur'),
};

const loadedLanguages = { en: true };

// Ensures a language's resource bundles are registered before i18next switches
// to it. No-op for English and for languages already loaded.
async function loadLanguage(lng) {
  if (loadedLanguages[lng] || !languageLoaders[lng]) {
    return;
  }
  const { default: bundle } = await languageLoaders[lng]();
  Object.entries(bundle).forEach(([ns, resources]) => {
    // deep = true (merge nested namespaces like `flash`), overwrite = true
    i18n.addResourceBundle(lng, ns, resources, true, true);
  });
  loadedLanguages[lng] = true;
}

// Wrap changeLanguage so every call site (flash, elements, customer, pixel)
// transparently loads the lazy bundle first — no call-site changes required.
const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = async (lng, ...rest) => {
  await loadLanguage(lng);
  return originalChangeLanguage(lng, ...rest);
};

export default i18n;
